import { useEffect, useState } from 'react';
import LoginForm from './LoginForm';
import './Login.css';

function BrandLockup({ compact = false }) {
  return (
    <div className={`mvp-brand-lockup${compact ? ' mvp-brand-lockup--compact' : ''}`}>
      <span className="mvp-brand-mark" aria-hidden="true">
        <span className="mvp-brand-mark__route" />
        <span className="mvp-brand-mark__pin" />
      </span>
      <span className="mvp-brand-copy">
        <strong>Manual Vendor</strong>
        <span>Portal</span>
      </span>
    </div>
  );
}

export default function Login({ setLoginSuccess }) {
  const [sessionNotice, setSessionNotice] = useState('');

  useEffect(() => {
    const queryReason = new URLSearchParams(window.location.search).get('session');
    if (sessionStorage.getItem('mvp_logout_reason') === 'inactivity' || queryReason === 'inactive') {
      setSessionNotice('You were signed out after 10 minutes of inactivity. Sign in again to continue.');
      sessionStorage.removeItem('mvp_logout_reason');

      if (queryReason === 'inactive') {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    }
  }, []);

  return (
    <main className="mvp-login-shell">
      <section className="mvp-login-story" aria-labelledby="mvp-login-heading">
        <div className="mvp-login-orbit mvp-login-orbit--one" aria-hidden="true" />
        <div className="mvp-login-orbit mvp-login-orbit--two" aria-hidden="true" />

        <div className="mvp-login-story__content">
          <BrandLockup />

          <div className="mvp-login-hero">
            <span className="mvp-login-eyebrow">Vendor operations, simplified</span>
            <h1 id="mvp-login-heading">
              Your rental business,
              <span> beautifully organized.</span>
            </h1>
            <p>
              Manage account-specific rates, fleet, locations, and reservations from one
              focused workspace built for your team.
            </p>

            <div className="mvp-login-capabilities" aria-label="Portal capabilities">
              <div className="mvp-login-capability">
                <span className="mvp-login-capability__icon" aria-hidden="true">01</span>
                <span>
                  <strong>Account control</strong>
                  <small>Keep each vendor's data clearly separated.</small>
                </span>
              </div>
              <div className="mvp-login-capability">
                <span className="mvp-login-capability__icon" aria-hidden="true">02</span>
                <span>
                  <strong>Operational clarity</strong>
                  <small>See the details your team needs, without the noise.</small>
                </span>
              </div>
            </div>
          </div>

          <div className="mvp-login-trust">
            <span className="mvp-login-trust__dot" aria-hidden="true" />
            Secure vendor workspace
          </div>
        </div>
      </section>

      <section className="mvp-login-access" aria-label="Sign in to Manual Vendor Portal">
        <div className="mvp-login-access__inner">
          <div className="mvp-login-mobile-brand">
            <BrandLockup compact />
          </div>

          <div className="mvp-login-card">
            {sessionNotice && (
              <div className="mvp-session-notice" role="status" aria-live="polite">
                <span className="mvp-session-notice__icon" aria-hidden="true">10</span>
                <span>
                  <strong>Session ended for your security</strong>
                  <small>{sessionNotice}</small>
                </span>
              </div>
            )}
            <LoginForm setLoginSuccess={setLoginSuccess} />
          </div>

          <p className="mvp-login-support">
            Need access help? <span>Contact your portal administrator.</span>
          </p>
        </div>
      </section>
    </main>
  );
}
